import { Fragments } from "requests";

export const getDefaultValues = (
  generalAssessment: Fragments.StoredGeneralAssessment
) => ({
  intraoralRadiographicComments:
    generalAssessment?.intraoralRadiographicComments || "",
  cbctComments: generalAssessment?.cbctComments || "",
  referralNotesAndComments: generalAssessment?.referralNotesAndComments || "",
  notesForClientDentalReport:
    generalAssessment?.notesForClientDentalReport || ""
});
